"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentOrElement = void 0;
var react_1 = __importDefault(require("react"));
var create_chainable_type_checker_1 = require("./utils/create-chainable-type-checker");
function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue;
  if (react_1.default.isValidElement(propValue)) {
    return new Error("Invalid " + location + " `" + propFullName + "` of type ReactElement " + ("supplied to `" + componentName + "`, expected a ReactComponent or a ") + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }
  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " + ("supplied to `" + componentName + "`, expected a ReactComponent or a ") + 'DOMElement.');
  }
  return null;
}
exports.componentOrElement = create_chainable_type_checker_1.createChainableTypeChecker(validate);